module.exports = __webpack_public_path__ + "img/icon-house.11f0a819.svg";